export const EditorialIngredientsImage = ({ className = "", eager = false }) => (
  <picture>
    <source
      type="image/avif"
      srcSet="/images/ingredient-editorial-640.avif 640w, /images/ingredient-editorial-960.avif 960w, /images/ingredient-editorial-1264.avif 1264w"
      sizes="(max-width: 768px) 100vw, 55vw"
    />
    <source
      type="image/webp"
      srcSet="/images/ingredient-editorial-640.webp 640w, /images/ingredient-editorial-960.webp 960w, /images/ingredient-editorial-1264.webp 1264w"
      sizes="(max-width: 768px) 100vw, 55vw"
    />
    <img
      src="/images/ingredient-editorial-1264.jpg"
      alt="Fresh pineapple, green apples, cucumber, limes, a watermelon wedge, an orange and a beet arranged on a warm ivory stone surface in natural daylight"
      width="1264"
      height="848"
      loading={eager ? "eager" : "lazy"}
      className={`w-full border border-[#171715]/10 ${className}`}
      data-testid="editorial-ingredients-image"
    />
  </picture>
);
